import { defineStore } from 'pinia';

import { DictType } from '@/api/client/types/DictsApiService';

export type DictionaryItem = {
  value: string | number;
  label: string;
  subDictionary?: string;
};
export type DictItem = {
  name: string;
  code: number;
  delete_mark: boolean;
};

export type DtoDict = {
  response: { data: DictItem[] };
};

type DictionariesStore = {
  //TODO не используется
  // districts: DictionaryItem[];
  // administrationUnits: DictionaryItem[];
  // regions: DictionaryItem[];
  // subjects: DictionaryItem[];
  [key in typeof cacheDictNamesArray[number]]: DtoDict;
};

//TODO посмотреть что можно закэшировать и как сделать лучше\правильнее
// Чтобы закэшировать словарь, надо просто добавить его название в множество
export const cacheDictNames = new Set([
  DictType.Genders,
  DictType.IdentityDocuments,
  DictType.LandCategories,
  DictType.TypeRuleToLands,
  DictType.ReasonForOpening,
  DictType.DocumentsOnAvailableRights,
  DictType.TypePermittedUseLands,
]);

const cacheDictNamesArray = Array.from(cacheDictNames);

export const useDictionariesStore = defineStore('dictionaries', {
  state: (): DictionariesStore => {
    const initialState = {} as DictionariesStore;
    cacheDictNamesArray.forEach(dictType => {
      initialState[dictType] = { response: { data: [] } };
    });
    return initialState;

    //TODO не используется
    // return {
    // administrationUnits: [
    //   { value: 1, label: 'Российская Федерация' },
    //   { value: 2, label: 'Федеральные округа', subDictionary: 'districts' },
    //   { value: 3, label: 'Экономические районы', subDictionary: 'regions' },
    //   { value: 4, label: 'Субеъкт', subDictionary: 'subjects' },
    // ],
    // regions: [
    //   {
    //     value: 'center',
    //     label: 'Центральный',
    //   },
    //   {
    //     value: 'center-zeml',
    //     label: 'Центрально-Черноземный',
    //   },
    //   {
    //     value: 'farEast',
    //     label: 'Дальневосточный',
    //   },
    //   {
    //     value: 'north',
    //     label: 'Северный',
    //   },
    //   {
    //     value: 'north-kavkaz',
    //     label: 'Серево-Кавказский',
    //   },
    //   {
    //     value: 'north-west',
    //     label: 'Серево-Западный',
    //   },
    //   {
    //     value: 'volga',
    //     label: 'Поволжский',
    //   },
    //   {
    //     value: 'ural',
    //     label: 'Уральский',
    //   },
    //   {
    //     value: 'volga-vatskiy',
    //     label: 'Волго-Вятский',
    //   },
    //   {
    //     value: 'west-north',
    //     label: 'Западно-Сибирский',
    //   },
    //   {
    //     value: 'kaliningrad',
    //     label: 'Калининградский',
    //   },
    // ],
    // districts: [
    //   {
    //     value: 'center',
    //     label: 'Центральный',
    //   },
    //   {
    //     value: 'north-vest',
    //     label: 'Северо-Западный',
    //   },
    //   {
    //     value: 'south',
    //     label: 'Южный ЮФО',
    //   },
    //   {
    //     value: 'north-kavkaz',
    //     label: 'Северо-Кавказкий',
    //   },
    //   {
    //     value: 'volga',
    //     label: 'Приволжский',
    //   },
    //   {
    //     value: 'ural',
    //     label: 'Уральский',
    //   },
    //   {
    //     value: 'sibir',
    //     label: 'Сибирский',
    //   },
    //   {
    //     value: 'farEast',
    //     label: 'Дальневосточный',
    //   },
    // ],
    // subjects: [
    //   {
    //     value: 'karelia',
    //     label: 'Республика Карелия',
    //   },
    //   {
    //     value: 'komi',
    //     label: 'Республика Коми',
    //   },
    //   {
    //     value: 'archangelsk',
    //     label: 'Архангельская область',
    //   },
    //   {
    //     value: 'neneskiy',
    //     label: 'Ненецкий автономный округ',
    //   },
    //   {
    //     value: 'murmanskiy',
    //     label: 'Мурманская область',
    //   },
    //   {
    //     value: 'voronesh',
    //     label: 'Воронежская область',
    //   },
    //   {
    //     value: 'kursk',
    //     label: 'Курская область',
    //   },
    //   {
    //     value: 'lipesk',
    //     label: 'Липецкая область',
    //   },
    //   {
    //     value: 'tambov',
    //     label: 'Тамбовская область',
    //   },
    //   {
    //     value: 'kalmkiy',
    //     label: 'Республика Калмыкия',
    //   },
    //   {
    //     value: 'center',
    //     label: 'Центральный',
    //   },
    //   {
    //     value: 'center-black',
    //     label: 'Центрально-Чернозёмный',
    //   },
    //   {
    //     value: 'east-sibir',
    //     label: 'Восточно-Сибирский',
    //   },
    // ],
    // };
  },
  actions: {
    setDictData(dictName: DictType, data: DictItem[]) {
      const dict = this[dictName];
      if (!dict) return { response: { data: [] } };

      return (dict.response.data = data);
    },
    getDictData(dictName: DictType): [DtoDict, number] {
      const dict = this[dictName];
      // TODO разобраться как типизировать
      return [dict, dict?.response?.data?.length];
    },
  },
});
